/* ============================================================
   CONFIG: every line of copy, every id, in one place.
   Sources: vr-quiz-campaign-build-261027.md §3 (questions, word for word); the lead's briefs
   (round 2, owner feedback Oct 27); card texts = the live Always Yours card (store photo) and
   vr-silent-husband-lid-sku-261022.md §8.1, word for word. Lines marked FILL are the builder's, PROVISIONAL.
   ============================================================ */

// Theme build (Oct 27 2026): image/video paths resolve to the theme asset URLs that
// templates/page.vr-quiz.liquid injects as window.VRQ_ASSETS; the local img/ path is the fallback.
const VRQ_ASSET = p => ((window.VRQ_ASSETS || {})[p] || p);
const config = {
  store: "https://www.vonriche.shop",
  defaultAngle: "sorry",
  autoAdvanceMs: 350,
  ga4Id: "",        // GA4 measurement id (G-XXXX). Empty = gtag not loaded.
  clarityId: "",    // Microsoft Clarity project id. Empty = Clarity not loaded.
  collectorUrl: "https://peru-walrus-913275.hostingersite.com/e", // first-party event collector (TRACKING.md §1). Empty = no beacon sent.

  openers: {  // card 1 (emoji kept here, owner round 2)
    sorry:  { q: "What happened between you two?", a: [["fight","We had a big fight","💥"], ["regret","I said something I regret","😔"], ["drifted","We've drifted apart lately","🥀"], ["letdown","I keep letting her down","💔"]] },
    thanks: { q: "What does she carry that nobody sees?", a: [["kids","The kids and the house","🏠"], ["baddays","My bad days","🌧️"], ["job","Her job and everything else","💼"], ["all","All of it","🫶"]] },
    xmas:   { q: "What did you get her last Christmas?", a: [["unused","Something she never used","📦"], ["giftcard","A gift card","💳"], ["flowers","Flowers or perfume","💐"], ["nothing","Nothing that made her cry","😢"]] }
  },
  years: { q: "How long have you been together?", bands: ["Under 5 years", "5–10", "10–20", "20+"],
           min: 1, max: 50, start: 10, unit: ["year", "years"], together: "together", next: "Continue →" }, // unit/together/next FILL
  lastTold: { q: "When did you last tell her what she means to you, in words?",
              a: [["week","This week"], ["cant","I can't remember"], ["notwords","I'm not a words guy"], ["never","Never like that"]] },
  feel: { q: "What do you want her to feel when she opens it?",
          a: [["sorry","That I'm sorry"], ["see","That I see everything she does"], ["choose","That I'd choose her again"], ["enough","That she's enough"]] },
  fact: { title: "Did you know?",
          lead: "Little things keep a marriage strong.",   // round 4 wording (owner: "simpler language", Oct 27)
          text: "A 6-year study. How often couples responded to each other's small moments:",
          source: "Source: The Gottman Institute",
          kicker: "She doesn't need a big gesture. She needs your words.",
          bars: [["Stayed married", 86], ["Divorced", 33]],
          img: VRQ_ASSET("img/couple_hug.jpg"), alt: "A couple holding each other", next: "Continue →" },
  names: { q: "Your names", sub: "for the engraving", her: "Her name", him: "Your name", // q FILL; labels from the lead's brief
           ph: ["e.g. Anna", "e.g. Mark"], err: "Please write both names.", next: "Continue →" },     // FILL
  stones: { qHer: "Her birthstone", qHim: "Your birthstone", sub: "Pick the month she was born" , subHim: "Pick the month you were born" }, // FILL wording; fields mirror the PDP
  months: ["January","February","March","April","May","June","July","August","September","October","November","December"],
  colors: ["#8e1d2d","#7b39ad","#57c1d6","#d8dee7","#0e8c4e","#b6a4d6","#cc1336","#97c732","#18409c","#e87aa0","#d98a1f","#27b1d6"], // the PDP's COLORS
  when: { q: "When do you need it?", a: [["xmas","Before Christmas","🎄"], ["anniv","Our anniversary is coming","🥂"], ["asap","As soon as possible","⚡"]],
          ship: { xmas: "For Christmas: made to order, free shipping. Order today.",            // FILL (no date promised)
                  anniv: "For your anniversary: made to order, free shipping. Order today.",
                  asap: "Made to order and shipped free, starting today." },
          // Round 5 (owner, Oct 27: "add the Ships free to STATE"): when the visitor's US state is known, the offer shows
          // "Ships free to {state}" and the line below instead of the one above. State from geo.ip (get.geojs.io, no key), US only.
          shipShort: { xmas: "Made to order. Order today for Christmas.", anniv: "Made to order. Order today for your anniversary.",
                       asap: "Made to order, starting today." } },
  shipTo: "Ships free to {state}",
  load1: { text: "Choosing her message…", ms: 1600 },
  // Reaction screen (owner, Oct 27: "reactions from the ads man, the crying montage"). Our own AI renders, never presented as buyers:
  // 4 approved montage keepers from her-montage-v2/out/ (M1_W1_couch_v2 2.5-4.5 s, M3_W3_bedroom_v5 2.5-4.5, M2_W2_kitchen_v2 2.0-4.0,
  // M4_W4_sofa_v4 1.5-3.5; 0.3 s dissolves, 7.1 s, 480x854, H.264, no audio). Copy from the lead's brief.
  reaction: { title: "The moment she reads it", line: "Words she'll read again and again.", src: VRQ_ASSET("img/reaction_montage.mp4"), poster: VRQ_ASSET("img/reaction_poster.jpg"), next: "Continue →" },
  reveal: { title: "Based on what you told us, this is her message.", next: "Continue →" },
  container: { q: "Where should your words live?" },
  load2: { text: "Engraving {her} & {him}…", text2: "Printing her card…", text2Lid: "Engraving her box…", ms: 4200 }, // text2Lid FILL (172: no printed card)
  offer: { title: "Complete her gift", metals: ["Silver", "Gold (+$20)"], line: "50% OFF + FREE SHIPPING", cta: "Complete my gift →" }, // title FILL
  // Shipping insurance (owner, Oct 27: "Add the $4.99 shipping insurance to the quiz checkout, matching the product page's default").
  // Same as the live PDP cart drawer (vr-cart-drawer ensureIns): product worry-free-shipping, variant below, qty 1, no properties,
  // ticked by default. Label = the drawer row's English wording (its 🛡 left out: emojis only on card 1 and "when").
  // Unticked = cart attribute _vr_ins_optout "1", the drawer's own opt-out, so the checkout block does not add it back.
  insurance: { variant: 47874535588072, price: "4.99", on: true, label: "Worry-free shipping", sub: "Coverage for lost parcels up to $250." },

  // Message pick. Round 5 (owner, Oct 27: "every answer leads to 124 card, dont use new cards"): every answer and every angle
  // gets the Always Yours "I am not perfect" card. The three new cards' texts and products stay below, unused.
  pickByFeel: { sorry: "notperfect", see: "notperfect", choose: "notperfect", enough: "notperfect" },
  angleDefault: { sorry: "notperfect", thanks: "notperfect", xmas: "notperfect" },
  messages: {
    // **bold** = the bold words on the printed card. Shown in capitals like the card.
    notperfect: { L: "I am not perfect. Sometimes I make you mad, forget important things, and say dumb stuff. But no matter what, you’re the **love of my life.**",
                  R: "If I could give you **one thing** in life, I would give you the ability to see yourself through my eyes, only then would you realize",
                  C: "How **special** you are to me. I didn’t marry you so I could live with you. I married you because **I can’t live without you.**" },
    wonder:     { L: "I know I go quiet. I know there are nights you lie next to me wondering if I still feel it. **I do.**",
                  R: "I feel it every morning while you're still asleep, and every night when the house goes quiet, and the words stay stuck in my throat.",
                  C: "So let this say it for me, **every time you wonder.** I didn't marry you so I could live with you. I married you because **I can't live without you.**" },
    knew:       { L: "I always thought you knew. I got up every morning and went to work, and I thought that was me saying it.",
                  R: "It took me too long to understand that **you can't hear a man who never says it.** So here it is, in words, where you can keep them.",
                  C: "You are **the reason I come home.** I didn't marry you so I could live with you. I married you because **I can't live without you.**" },
    yearsago:   { L: "I should have said this years ago. Not on our anniversary, not on your birthday. On an ordinary Tuesday, **for no reason at all.**",
                  R: "I let too many ordinary days go by thinking you knew. So read this on every one of them, **until you do.**",
                  C: "You are still the best thing that ever happened to me. I didn't marry you so I could live with you. I married you because **I can't live without you.**" }
  },
  signoff: "I love you forever & always.",

  // Products (Shopify Admin API, read only, Oct 27). Variant ids per metal; prices = [price, compare].
  // props: line-item properties exactly as the live PDP sends them (verified on /cart.js).
  showcase: { t: "Showcase: the LED box", d: "Lights up the moment she opens it, ready to present." },
  keepsakeLid: { t: "Keepsake: the beech box", d: "Your words engraved on the lid, a box she keeps forever." },      // FILL
  keepsakeWhite: { t: "Classic: the white box", d: "Your card in a classic white gift box." },                      // FILL
  boxLine: { led: "Your card in the LED box that lights up", lid: "Your words engraved on a light beech box", white: "Your card in the classic white gift box" }, // FILL
  products: {
    notperfect: {
      led:  { handle: "always-yours-birthstone-heart-necklace", cl: "cliatnrifxsg",
              v: { silver: ["47827608961256", "79.95", "159.90"], gold: ["47827609026792", "99.95", "199.90"] },
              img: "https://cdn.shopify.com/s/files/1/0702/7071/4088/files/hf_20260901_074739_6b95ee31-c2b8-475c-8f8c-163540aab31f.png?v=1788251281&width=700" },
      keep: { kind: "lid", handle: "172", cl: "cldvweshihvg",
              v: { silver: ["48905112944872", "59.95", "119.90"], gold: ["48905113010408", "79.95", "159.90"] },
              img: "https://cdn.shopify.com/s/files/1/0702/7071/4088/files/vr-172-wood-card-en.jpg?v=1791533555&width=700" } },
    wonder: {
      led:  { handle: "to-my-wife-wonder", cl: "cliatnrifxsg",
              v: { silver: ["67961920880872", "79.95", "159.90"], gold: ["67961920913640", "99.95", "199.90"] },
              img: "https://cdn.shopify.com/s/files/1/0702/7071/4088/files/vr-card-wonder-hero.png?v=1792667423&width=700" },
      keep: { kind: "white", handle: "to-my-wife-wonder", cl: "cliatnrifxsg",
              v: { silver: ["67961972457704", "59.95", "119.90"], gold: ["67961972490472", "79.95", "159.90"] },
              img: VRQ_ASSET("img/whitebox_wonder.jpg") } },
    knew: {
      led:  { handle: "to-my-wife-knew", cl: "cliatnrifxsg",
              v: { silver: ["67961921077480", "79.95", "159.90"], gold: ["67961921110248", "99.95", "199.90"] },
              img: "https://cdn.shopify.com/s/files/1/0702/7071/4088/files/vr-card-knew-hero.png?v=1792667432&width=700" },
      keep: { kind: "white", handle: "to-my-wife-knew", cl: "cliatnrifxsg",
              v: { silver: ["67961972654312", "59.95", "119.90"], gold: ["67961972687080", "79.95", "159.90"] },
              img: VRQ_ASSET("img/whitebox_knew.jpg") } },
    yearsago: {
      led:  { handle: "to-my-wife-years-ago", cl: "cliatnrifxsg",
              v: { silver: ["67961921306856", "79.95", "159.90"], gold: ["67961921339624", "99.95", "199.90"] },
              img: "https://cdn.shopify.com/s/files/1/0702/7071/4088/files/vr-card-yearsago-hero.png?v=1792667434&width=700" },
      keep: { kind: "white", handle: "to-my-wife-years-ago", cl: "cliatnrifxsg",
              v: { silver: ["67961972785384", "59.95", "119.90"], gold: ["67961972818152", "79.95", "159.90"] },
              img: VRQ_ASSET("img/whitebox_yearsago.jpg") } }
  },
  // The live PDP's pendant mockup (vr-pdp-cfg: mock2 layers, arm paths, gem positions).
  mock: { files: "https://cdn.shopify.com/s/files/1/0702/7071/4088/files/vr-mock2-",
          gem: { silver: { P: [359,500,136,150], B: [507,496,147,156] }, gold: { P: [350,501,147,149], B: [508,498,151,155] } },
          arm: { gold: { L: "M253 574 C279 665 361 722 429 782", R: "M565 782 C635 724 712 663 742 574" },
                 silver: { L: "M250 574 C278 664 359 722 428 782", R: "M552 782 C627 724 702 663 735 574" } },
          px: 50, max: 232 }
};

/* ============================================================ STATE */
const Q = new URLSearchParams(location.search);
const angle = config.openers[Q.get("a")] ? Q.get("a") : config.defaultAngle;
const DEBUG = Q.get("debug") === "1";
const S = { opener: null, yearsN: config.years.start, lastTold: null, feel: null, her: "", him: "", herStone: null, himStone: null,
            when: null, msg: null, box: null, metal: "silver", ins: config.insurance.on, state: "" };
const steps = ["opener","years","lastTold","feel","fact","names","stoneHer","stoneHim","when","load1","message","reaction","container","load2","offer"];   // round 3: "Her necklace" step removed, load2 goes straight to the offer
const QNUM = { opener:1, years:2, lastTold:3, feel:4, names:5, stoneHer:6, stoneHim:6, when:7 };
const READING = { fact:1, message:1, reaction:1, offer:1 };
const QUESTIONS = 7;
let i = 0, busy = false, timer = null, started = false, answered = 0;
const stage = document.getElementById("stage"), bar = document.getElementById("bar"), back = document.getElementById("back");

/* ============================================================ TRACKING (TRACKING.md §1-3)
   GA4 (gtag 'quiz_<ev>') + Microsoft Clarity + guarded fbq. No names or free text, ever. */
const T0 = Date.now();
const SID = (() => { try { let s = sessionStorage.getItem("vrq_sid"); if (!s) { s = Math.random().toString(36).slice(2, 10) + Date.now().toString(36); sessionStorage.setItem("vrq_sid", s); } return s; } catch (e) { return "nosess" + Math.random().toString(36).slice(2, 10); } })();
const COMMON = {
  v: 1, sid: SID, angle,
  utm_source: Q.get("utm_source") || "", utm_campaign: Q.get("utm_campaign") || "", utm_content: Q.get("utm_content") || "",
  fbclid: Q.has("fbclid"), ref: (() => { try { return document.referrer ? new URL(document.referrer).hostname : ""; } catch (e) { return ""; } })(),
  mobile: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) || matchMedia("(pointer:coarse)").matches,
  w: innerWidth, h: innerHeight,
  page: "live"   // store version (TRACKING.md common fields)
};
const CLARITY_EVENTS = { step_view:1, answer:1, read:1, cta:1, start:1, pick:1 };
(function loadTags(){
  if (config.ga4Id) {
    const s = document.createElement("script"); s.async = true; s.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(config.ga4Id); document.head.appendChild(s);
    window.dataLayer = window.dataLayer || []; window.gtag = function(){ dataLayer.push(arguments); };
    gtag("js", new Date()); gtag("config", config.ga4Id, { send_page_view: true });
  }
  if (config.clarityId) {
    (function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script",config.clarityId);
    clarity("set", "angle", angle); clarity("set", "ad", COMMON.utm_content || "none"); clarity("identify", SID);
  }
})();
function track(ev, data){
  const step = steps[i];
  const e = Object.assign({}, COMMON, { ts: Date.now(), ev, step, i }, data || {});
  if (DEBUG) console.log("[quiz]", ev, e);
  try {
    if (window.gtag && config.ga4Id) {
      const p = {}; let n = 0;  // flat params, at most 25
      for (const k in e) { if (k === "ev" || n >= 25) continue; const val = e[k]; p[k] = typeof val === "boolean" ? String(val) : val; n++; }
      window.gtag("event", "quiz_" + ev, p);
    }
  } catch (x) {}
  try { if (window.clarity && config.clarityId && CLARITY_EVENTS[ev]) window.clarity("event", "quiz_" + ev); } catch (x) {}
  if (config.collectorUrl) {  // sendBeacon text/plain (no preflight), fetch keepalive fallback
    const body = JSON.stringify(e);
    try { if (!(navigator.sendBeacon && navigator.sendBeacon(config.collectorUrl, new Blob([body], { type: "text/plain" }))))
      fetch(config.collectorUrl, { method: "POST", body, keepalive: true, mode: "no-cors", headers: { "Content-Type": "text/plain" } }).catch(() => {}); } catch (x) {}
  }
}
function fb(name, params){ try { if (window.fbq) window.fbq("trackCustom", name, params || {}); } catch (x) {} }
window.addEventListener("error", ev => track("error", { message: String(ev.message || "error").slice(0, 200) }));
window.addEventListener("unhandledrejection", ev => track("error", { message: String((ev.reason && ev.reason.message) || ev.reason || "rejection").slice(0, 200) }));

/* per-card measurement: time, deepest scroll, visible time, reached end */
let card = null;
function cardStart(){
  card = { step: steps[i], i, t0: Date.now(), visMs: 0, visFrom: document.hidden ? null : Date.now(), maxPct: 0, end: false, io: null };
  measureScroll();
  const end = stage.querySelector(".end");
  if (end && "IntersectionObserver" in window) {
    card.io = new IntersectionObserver(es => es.forEach(x => { if (x.isIntersecting && card) card.end = true; }), { threshold: 1 });
    card.io.observe(end);
  }
}
function measureScroll(){
  if (!card) return;
  const doc = document.documentElement, h = Math.max(doc.scrollHeight, 1);
  const pct = Math.min(100, Math.round((scrollY + innerHeight) / h * 100));
  if (pct > card.maxPct) card.maxPct = pct;
}
addEventListener("scroll", measureScroll, { passive: true });
function cardEnd(){
  if (!card) return;
  const ms = Date.now() - card.t0;
  if (card.visFrom) { card.visMs += Date.now() - card.visFrom; card.visFrom = null; }
  if (card.io) card.io.disconnect();
  track("scroll", { max_pct: card.maxPct, ms });
  if (READING[card.step]) track("read", { visible_ms: card.visMs, reached_end: card.end, max_pct: card.maxPct });
  if (card.step === "years") track("slider", { value: S.yearsN, moves: sliderMoves });
  videoEnd();
  card = null;
}
/* reaction video: "started" once it plays, seconds actually watched (loops counted) sent when the card is left */
let VID = null;
function wireReaction(){
  const v = document.getElementById("rvid"); if (!v) return;
  VID = { started: false, watched: 0, last: null, t0: Date.now() };
  v.muted = true;
  v.addEventListener("playing", () => { if (VID && !VID.started) { VID.started = true; track("video", { state: "started", ms: Date.now() - VID.t0 }); } });
  v.addEventListener("timeupdate", () => { if (!VID) return; const t = v.currentTime; if (VID.last !== null && t > VID.last && t - VID.last < 1) VID.watched += t - VID.last; VID.last = t; });
  const p = v.play(); if (p && p.catch) p.catch(() => {});
}
function videoEnd(){
  if (!VID) return;
  track("video", { state: "leave", started: VID.started, watched_s: Math.round(VID.watched * 10) / 10 });
  VID = null;
}
document.addEventListener("visibilitychange", () => {
  if (document.hidden) { if (card && card.visFrom) { card.visMs += Date.now() - card.visFrom; card.visFrom = null; } track("hidden"); }
  else { if (card) card.visFrom = Date.now(); track("visible"); }
});
addEventListener("pagehide", () => { videoEnd(); }); addEventListener("pagehide", () => track("leave", { last: steps[i], ms: Date.now() - T0, answered }));

/* ============================================================ HELPERS */
function esc(s){ return String(s).replace(/[&<>"]/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c])); }
// The PDP's name rule (vr-pdp-js v2.53): NFKC, Latin letters + space ' ’ . -, Title Case, max 10.
const NAME_OK = /[^A-Za-zÀ-ÖØ-öø-ɏ '’.\-]/g;
function fixName(s){ s = String(s || ""); try { s = s.normalize("NFKC"); } catch (e) {} s = s.replace(NAME_OK, "").replace(/ {2,}/g, " ").replace(/^ +/, "");
  s = s.toLowerCase().replace(/(^|[ '’.\-])([a-zß-öø-ɏ])/g, (m, p, c) => p + c.toUpperCase()); return s.slice(0, 10); }
function msgKey(){ return config.pickByFeel[S.feel] || config.angleDefault[angle]; }
function prod(){ const m = config.products[S.msg || msgKey()]; return S.box === "keep" ? m.keep : m.led; }
function variant(){ return prod().v[S.metal]; }
function yearsLabel(n){ const u = config.years.unit; return (n >= config.years.max ? n + "+" : n) + " " + (n === 1 ? u[0] : u[1]); }
function yearsBand(n){ const b = config.years.bands; return n < 5 ? b[0] : n < 10 ? b[1] : n < 20 ? b[2] : b[3]; }
function boldify(t){ return esc(t).replace(/\*\*(.+?)\*\*/g, "<b>$1</b>"); }
function stoneVal(idx){ return (idx + 1) + ". " + config.months[idx]; }   // the PDP's value format, e.g. "7. July"
const CHK = `<span class="chk">✓</span>`;

// POST, never GET: a GET /cart/add sorts properties and attributes by name ("Her Birthstone" first), POST keeps this order
// (tested on /cart.js, Oct 30). The supplier reads the engraving values in this order.
function checkoutFields(){
  const p = prod(), v = variant(), q = new URLSearchParams();
  // one POST /cart/add with items[]: the necklace (+ its properties) and, when ticked, the insurance line
  q.append("items[0][id]", v[0]); q.append("items[0][quantity]", "1");
  // line-item properties: same keys, order and formats as the live PDP's add to cart
  q.append("items[0][properties][His Name]", fixName(S.him).trim());
  q.append("items[0][properties][His Birthstone]", stoneVal(S.himStone));
  q.append("items[0][properties][Her Name]", fixName(S.her).trim());
  q.append("items[0][properties][Her Birthstone]", stoneVal(S.herStone));
  q.append("items[0][properties][_cl_options]", p.cl);
  if (S.ins) { q.append("items[1][id]", config.insurance.variant); q.append("items[1][quantity]", "1"); }
  // the drawer's opt-out attribute: "1" when unticked (checkout block respects it), "" when ticked (clears a stale opt-out)
  q.append("attributes[_vr_ins_optout]", S.ins ? "" : "1");
  // order join (TRACKING.md §2): cart attributes, verified to land on /cart.js
  q.append("attributes[_quiz_sid]", SID);
  q.append("attributes[_quiz_angle]", angle);
  q.append("attributes[_quiz_msg]", S.msg);
  q.append("attributes[_quiz_box]", p.kind === "lid" ? "lid" : (S.box === "keep" ? "white" : "led"));
  if (COMMON.utm_content) q.append("attributes[_quiz_utm_content]", COMMON.utm_content);
  if (COMMON.utm_source) q.append("attributes[_quiz_utm_source]", COMMON.utm_source);
  q.append("return_to", "/checkout");
  return [...q].map(([k, val]) => `<input type="hidden" name="${esc(k)}" value="${esc(val)}">`).join("");
}

/* pendant preview: the PDP's layered mockup with their names and stones */
function tint(hex){ const n = parseInt(hex.slice(1), 16), c = [n >> 16 & 255, n >> 8 & 255, n & 255].map(v => Math.min(1.35, (v / 255) * 1.18 + 0.04).toFixed(3));
  return `${c[0]} 0 0 0 0  0 ${c[1]} 0 0 0  0 0 ${c[2]} 0 0  0 0 0 1 0`; }
function pendantSVG(){
  const M = config.mock, met = S.metal, g = M.gem[met], f = M.files + met + "-", arm = M.arm[met];
  const his = config.colors[S.himStone], hers = config.colors[S.herStone];
  return `<div class="mock ${met}"><svg id="pendant" viewBox="108 82 778 860" role="img" aria-label="Preview of her necklace">
    <defs><filter id="tP" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="${tint(his)}"/></filter>
    <filter id="tB" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="${tint(hers)}"/></filter>
    <path id="armL" d="${arm.L}"/><path id="armR" d="${arm.R}"/></defs>
    <image class="base ${met}" href="${f}base.webp" x="0" y="0" width="1024" height="1024"/>
    <image class="gl ${met}" href="${f}P-lum.png" x="${g.P[0]}" y="${g.P[1]}" width="${g.P[2]}" height="${g.P[3]}" filter="url(#tP)"/>
    <image class="gl ${met}" href="${f}P-spec.png" x="${g.P[0]}" y="${g.P[1]}" width="${g.P[2]}" height="${g.P[3]}"/>
    <image class="gl ${met}" href="${f}B-lum.png" x="${g.B[0]}" y="${g.B[1]}" width="${g.B[2]}" height="${g.B[3]}" filter="url(#tB)"/>
    <image class="gl ${met}" href="${f}B-spec.png" x="${g.B[0]}" y="${g.B[1]}" width="${g.B[2]}" height="${g.B[3]}"/>
    <text class="engr" id="lpN1" dominant-baseline="auto" dy="0.30em"><textPath href="#armL" startOffset="50%" text-anchor="middle">${esc(fixName(S.him))}</textPath></text>
    <text class="engr" id="lpN2" dominant-baseline="auto" dy="0.5em"><textPath href="#armR" startOffset="50%" text-anchor="middle">${esc(fixName(S.her))}</textPath></text>
  </svg></div>`;
}
function fitNames(){ // the PDP's fitName: 50 px, shrink only past 232 units
  ["lpN1","lpN2"].forEach(id => { const el = document.getElementById(id); if (!el) return; el.style.fontSize = config.mock.px + "px";
    try { const len = el.firstElementChild.getComputedTextLength(); if (len > config.mock.max) el.style.fontSize = (config.mock.px * config.mock.max / len).toFixed(1) + "px"; } catch (e) {} });
}

/* ============================================================ RENDER */
function head(key, q, sub){ return `<div class="step">${QNUM[key]} of ${QUESTIONS}</div><h1>${esc(q)}</h1>${sub ? `<p class="sub">${esc(sub)}</p>` : ""}`; }
function tiles(key, list, emoji){
  const one = list.length === 3 ? " one" : "";
  return `<div class="tiles${one}${emoji ? " emo" : ""}">` + list.map(o =>
    `<button class="tile${S[key] === o[0] ? " sel" : ""}" data-k="${key}" data-v="${o[0]}">${emoji ? `<span class="ic">${o[2]}</span>` : ""}<span>${esc(o[1])}</span>${CHK}</button>`).join("") + `</div>`;
}
function gems(key){
  return `<div class="gems">` + config.months.map((m, n) =>
    `<button class="gm${S[key] === n ? " sel" : ""}" data-k="${key}" data-v="${n}" aria-label="${m}"><span class="orb" style="background:${config.colors[n]}"></span>${m.slice(0,3)}${CHK}</button>`).join("") + `</div>`;
}
function fill(t){ return t.replace("{her}", esc(fixName(S.her))).replace("{him}", esc(fixName(S.him))); }

function render(dir, silent){
  const key = steps[i];
  let h = "";
  if (key === "opener")   h = head(key, config.openers[angle].q) + tiles(key, config.openers[angle].a, true);
  if (key === "lastTold") h = head(key, config.lastTold.q) + tiles(key, config.lastTold.a);
  if (key === "feel")     h = head(key, config.feel.q) + tiles(key, config.feel.a);
  if (key === "when")     h = head(key, config.when.q) + tiles(key, config.when.a, true);
  if (key === "years") {
    const y = config.years;
    h = head(key, y.q) + `<div class="years"><div class="heart" id="heart">❤️</div>
        <div class="ybig" id="ybig"></div><div class="ysub">${esc(y.together)}</div>
        <input type="range" id="yr" min="${y.min}" max="${y.max}" step="1" value="${S.yearsN}" aria-label="${esc(y.q)}">
        <div class="ticks"><span>1</span><span>10</span><span>20</span><span>30</span><span>40</span><span>${y.max}+</span></div>
        <button class="cta" data-next>${esc(y.next)}</button></div>`;
  }
  if (key === "fact") {
    const f = config.fact;
    h = `<img class="bimg" src="${f.img}" alt="${esc(f.alt)}"><div class="eyebrow">${esc(f.title)}</div><p class="flead">${esc(f.lead)}</p><p class="fact">${esc(f.text)}</p>
      <div class="bars">${f.bars.map(([l, v], n) => `<div class="brow"><span>${esc(l)}</span><div class="btrack"><div class="bfill ${n ? "b" : "a"}" data-w="${v}"></div></div><span class="bnum" data-n="${v}">0%</span></div>`).join("")}</div>
      <p class="src">${esc(f.source)}</p><p class="kicker">${esc(f.kicker)}</p><div class="end"></div>
      <button class="cta" data-next>${esc(f.next)}</button>`;
  }
  if (key === "names") {
    const n = config.names;
    h = head(key, n.q, n.sub) + `
      <label class="field"><span>${esc(n.her)}</span><input id="inHer" data-clarity-mask="true" autocomplete="off" autocapitalize="words" maxlength="20" placeholder="${esc(n.ph[0])}" value="${esc(S.her)}"><small id="cHer">0/10</small></label>
      <label class="field"><span>${esc(n.him)}</span><input id="inHim" data-clarity-mask="true" autocomplete="off" autocapitalize="words" maxlength="20" placeholder="${esc(n.ph[1])}" value="${esc(S.him)}"><small id="cHim">0/10</small></label>
      <p class="err" id="nErr"></p><button class="cta" data-next="names">${esc(n.next)}</button>`;
  }
  if (key === "stoneHer") h = head("stoneHer", config.stones.qHer, config.stones.sub) + gems("herStone");
  if (key === "stoneHim") h = head("stoneHim", config.stones.qHim, config.stones.subHim) + gems("himStone");
  if (key === "load1") h = `<div class="loading"><div class="ring"></div><p>${esc(config.load1.text)}</p><div class="loadbar" style="--d:${config.load1.ms}ms"><i></i></div></div>`;
  if (key === "reaction") {
    const r = config.reaction;
    h = `<h1>${esc(r.title)}</h1><p class="sub">${esc(r.line)}</p>
      <video class="rvid" id="rvid" src="${r.src}" poster="${r.poster}" autoplay muted loop playsinline preload="auto"></video>
      <div class="end"></div><button class="cta" data-next>${esc(r.next)}</button>`;
  }
  if (key === "message") {
    const m = config.messages[S.msg];
    h = `<h1>${esc(config.reveal.title)}</h1>
      <div class="mcard" id="mcard"><div class="tm">To My</div><div class="wf">WIFE</div>
        ${["L","R","C"].map(k => `<p class="mp">${wordsHTML(m[k])}</p>`).join("")}
        <div class="so" id="so">${esc(config.signoff)}</div></div>
      <div class="end"></div><button class="cta" data-next>${esc(config.reveal.next)}</button>`;
  }
  if (key === "container") {
    const P = config.products[S.msg], kp = P.keep.kind === "lid" ? config.keepsakeLid : config.keepsakeWhite;
    h = `<h1>${esc(config.container.q)}</h1><div class="ptiles">
      <button class="ptile${S.box === "led" ? " sel" : ""}" data-k="box" data-v="led"><img src="${P.led.img}" alt="LED box"><span class="t">${esc(config.showcase.t)}</span><span class="d">${esc(config.showcase.d)}</span>${CHK}</button>
      <button class="ptile${S.box === "keep" ? " sel" : ""}" data-k="box" data-v="keep"><img src="${P.keep.img}" alt="${esc(kp.t)}"><span class="t">${esc(kp.t)}</span><span class="d">${esc(kp.d)}</span>${CHK}</button></div>`;
  }
  if (key === "load2") {
    const t2 = prod().kind === "lid" ? config.load2.text2Lid : config.load2.text2;
    h = `<div class="loading"><div class="ring"></div><p>${fill(config.load2.text)}</p><p class="l2">${esc(t2)}</p><div class="loadbar" style="--d:${config.load2.ms}ms"><i></i></div></div>`;
  }
  if (key === "offer") {
    const p = prod(), boxTxt = config.boxLine[p.kind === "lid" ? "lid" : (S.box === "keep" ? "white" : "led")];
    {
      const v = variant();
      h = `<h1>${esc(config.offer.title)}</h1>${pendantSVG()}
        <div class="metal">${["silver","gold"].map((m, n) => `<button class="${S.metal === m ? "sel" : ""}" data-metal="${m}">${esc(config.offer.metals[n])}</button>`).join("")}</div>
        <div class="boxrow"><img src="${p.img}" alt=""><span>${esc(boxTxt)}</span></div>
        <p class="offer">${esc(config.offer.line)}</p>
        <p class="price"><s>$${v[2]}</s>$${v[1]}</p>
        ${S.state ? `<p class="ship"><b>${esc(config.shipTo.replace("{state}", S.state))}</b><br>${esc(config.when.shipShort[S.when] || "")}</p>`
                  : `<p class="ship">${esc(config.when.ship[S.when] || "")}</p>`}
        <label class="ins"><input type="checkbox" id="ins"${S.ins ? " checked" : ""}><span>${esc(config.insurance.label)} · <b>$${config.insurance.price}</b><small>${esc(config.insurance.sub)}</small></span></label>
        <form method="post" action="${config.store}/cart/add"><div id="ckv">${checkoutFields()}</div><button class="cta" id="cta">${esc(config.offer.cta)}</button></form><div class="end"></div>`;
    }
  }
  stage.innerHTML = `<section class="card${dir === "back" ? " back-in" : ""}"${silent ? ' style="animation:none"' : ""}>${h}</section>`;
  bar.style.width = Math.round(((i + 1) / steps.length) * 100) + "%";
  back.classList.toggle("on", i > 0 && !/^load/.test(key));
  if (!silent) window.scrollTo(0, 0);
  if (key === "years") wireYears();
  if (key === "names") wireNames();
  if (key === "fact") setTimeout(animateBars, 250);
  if (key === "message") typeMessage();
  if (key === "reaction") wireReaction();
  if (key === "offer") requestAnimationFrame(fitNames);
  if (/^load/.test(key)) { clearTimeout(timer); timer = setTimeout(() => go(1), key === "load1" ? config.load1.ms : config.load2.ms); }
  if (silent) { const end = stage.querySelector(".end"); if (card && card.io && end) card.io.observe(end); return; }   // in-card update (metal switch): no new step_view, same card measurement
  track("step_view");
  fb("QuizStep", { step: key, i, angle });
  if (key === "message") { track("pick", { kind: "message", value: S.msg }); fb("QuizComplete", { angle, msg: S.msg }); }
  cardStart();
}

function wordsHTML(t){
  // split into words, keep **bold** runs, each word a span revealed in order
  const out = []; let bold = false;
  t.split(/(\*\*)/).forEach(part => { if (part === "**") { bold = !bold; return; }
    part.split(/(\s+)/).forEach(w => { if (!w) return; if (/^\s+$/.test(w)) { out.push(" "); return; }
      out.push(`<span class="w">${bold ? "<b>" + esc(w) + "</b>" : esc(w)}</span>`); }); });
  return out.join("");
}
function typeMessage(){
  const ws = [...stage.querySelectorAll("#mcard .w")]; let k = 0;
  const tick = () => { if (steps[i] !== "message") return; if (k < ws.length) { ws[k++].classList.add("on"); timer = setTimeout(tick, 45); } else { const so = document.getElementById("so"); if (so) so.classList.add("on"); } };
  clearTimeout(timer); timer = setTimeout(tick, 300);
  document.getElementById("mcard").addEventListener("click", () => { ws.forEach(w => w.classList.add("on")); k = ws.length; const so = document.getElementById("so"); if (so) so.classList.add("on"); });
}
let sliderMoves = 0;
function wireYears(){
  const r = document.getElementById("yr"), big = document.getElementById("ybig"), heart = document.getElementById("heart");
  const upd = () => { const n = +r.value; S.yearsN = n; big.textContent = yearsLabel(n);
    heart.style.transform = `scale(${(0.6 + (n - 1) / (config.years.max - 1) * 1.3).toFixed(3)})`;
    r.style.setProperty("--p", ((n - r.min) / (r.max - r.min) * 100) + "%"); };
  r.addEventListener("input", () => { sliderMoves++; upd(); }); upd();
}
function wireNames(){
  [["inHer","her","cHer"],["inHim","him","cHim"]].forEach(([id, k, c]) => {
    const inp = document.getElementById(id), cnt = document.getElementById(c);
    const apply = () => { const fx = fixName(inp.value); if (fx !== inp.value) inp.value = fx; S[k] = fx; cnt.textContent = fx.length + "/10"; };
    inp.addEventListener("input", apply); inp.addEventListener("blur", () => { inp.value = inp.value.trim(); apply(); }); apply();
  });
}
function animateBars(){
  document.querySelectorAll(".bfill").forEach(b => b.style.width = b.dataset.w + "%");
  document.querySelectorAll(".bnum").forEach(el => { const to = +el.dataset.n, t0 = performance.now(), dur = 1400;
    const tk = t => { const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(to * e) + "%"; if (k < 1) requestAnimationFrame(tk); }; requestAnimationFrame(tk); });
}

function go(delta){
  let target = i + delta;
  while (delta < 0 && target > 0 && /^load/.test(steps[target])) target--;   // back skips loaders
  target = Math.max(0, Math.min(steps.length - 1, target));
  clearTimeout(timer);
  cardEnd();
  const c = stage.querySelector(".card");
  const next = () => { i = target; busy = false; render(delta < 0 ? "back" : "fwd"); };
  if (c && delta > 0) { c.classList.add("out"); setTimeout(next, 170); } else next();
}

stage.addEventListener("change", e => {
  if (e.target.id !== "ins") return;
  S.ins = e.target.checked; track("pick", { kind: "insurance", value: S.ins ? "on" : "off" });
  const f = document.getElementById("ckv"); if (f) f.innerHTML = checkoutFields();
});

stage.addEventListener("click", e => {
  const m = e.target.closest("[data-metal]");
  if (m) { S.metal = m.dataset.metal; track("pick", { kind: "metal", value: S.metal }); const y = scrollY; render("same", true); scrollTo(0, y); return; }
  const cta = e.target.closest("#cta");
  if (cta) { const p = prod(); track("cta", { variant: variant()[0], product: p.handle, msg: S.msg, box: p.kind === "lid" ? "lid" : S.box === "keep" ? "white" : "led", metal: S.metal });
             fb("QuizCheckoutClick", { angle, msg: S.msg }); cardEnd(); return; }   // the form posts to /cart/add, then checkout
  const b = e.target.closest("[data-k],[data-next]");
  if (!b || busy) return;
  if (b.hasAttribute("data-next")) {
    if (b.dataset.next === "names") {
      if (!S.her.trim() || !S.him.trim()) { document.getElementById("nErr").textContent = config.names.err; return; }
      track("answer", { answer: "names", name_her: !!S.her.trim(), name_him: !!S.him.trim(), ms: card ? Date.now() - card.t0 : 0 }); answered++;
    }
    if (steps[i] === "years") { track("answer", { answer: yearsBand(S.yearsN), value: S.yearsN, ms: card ? Date.now() - card.t0 : 0 }); answered++; }
    busy = true; return go(1);
  }
  const k = b.dataset.k, raw = b.dataset.v;
  const val = (k === "herStone" || k === "himStone") ? +raw : raw;
  S[k] = val;
  if (!started) { started = true; track("start"); fb("QuizStart", { angle }); }
  track("answer", { answer: k + ":" + raw, ms: card ? Date.now() - card.t0 : 0 }); answered++;
  if (k === "herStone" || k === "himStone") track("pick", { kind: "stone", value: (k === "herStone" ? "her:" : "him:") + config.months[val] });
  if (k === "box") track("pick", { kind: "container", value: raw });
  if (k === "when") { S.msg = msgKey(); }
  stage.querySelectorAll(`[data-k="${k}"]`).forEach(x => x.classList.toggle("sel", x === b));
  b.classList.add("pop"); busy = true;
  setTimeout(() => go(1), config.autoAdvanceMs);
});
back.addEventListener("click", () => { if (/^load/.test(steps[i])) return; track("back", { from: steps[i] }); busy = false; go(-1); });

track("load");
render();
// "Ships free to {state}": the visitor's US state by IP, looked up once; any failure keeps the plain shipping line.
if (DEBUG && Q.get("state")) S.state = Q.get("state").slice(0, 30);   // QA only: &debug=1&state=Texas
else (function(){ const c = new AbortController(); setTimeout(() => c.abort(), 4000);
  fetch("https://get.geojs.io/v1/ip/geo.json", { signal: c.signal }).then(r => r.json()).then(g => {
    if (g && g.country_code === "US" && g.region && /^[A-Za-z .]{2,30}$/.test(g.region)) { S.state = g.region; if (steps[i] === "offer") { const y = scrollY; render("same", true); scrollTo(0, y); } }
  }).catch(() => {}); })();
setTimeout(() => { // warm the photos so no card opens blank
  const urls = [config.fact.img, config.reaction.poster]; Object.values(config.products).forEach(p => urls.push(p.led.img, p.keep.img));
  ["silver","gold"].forEach(m => ["base.webp","P-lum.png","P-spec.png","B-lum.png","B-spec.png"].forEach(f => urls.push(config.mock.files + m + "-" + f)));
  urls.forEach(u => { const im = new Image(); im.src = u; });
}, 800);
